import type { SVGProps } from "react";
import * as React from "react";

export const ShieldXIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} fill="none" {...props}>
        <path
            fill="#6E767D"
            fillRule="evenodd"
            d="M6.613 1.314a.583.583 0 0 1 .773 0 6.417 6.417 0 0 0 4.545 1.605c.269-.013.51.16.587.418a7.583 7.583 0 0 1-5.372 9.479.584.584 0 0 1-.293 0 7.584 7.584 0 0 1-5.371-9.48.583.583 0 0 1 .586-.417 6.417 6.417 0 0 0 4.545-1.605ZM2.492 4.091A6.417 6.417 0 0 0 7 11.647a6.415 6.415 0 0 0 4.508-7.556A7.584 7.584 0 0 1 7 2.508a7.584 7.584 0 0 1-4.508 1.583ZM5.42 5.422a.583.583 0 0 1 .824 0L7 6.176l.754-.754a.583.583 0 1 1 .825.825l-.754.754.754.754a.583.583 0 1 1-.825.825L7 7.826l-.755.754a.583.583 0 0 1-.824-.825l.754-.754-.754-.754a.583.583 0 0 1 0-.825Z"
            clipRule="evenodd"
        />
    </svg>
);
